<template>
  <div class="min-max-selector">
    <div class="legend mb5">{{ legend }}</div>
    <div>
      <span>
        <span>{{ $t('message.MINIMUM_SHORT') + $t('message.TWO_DOTS') }}</span>
        <InputNumber v-model="minValue" @input="edited" />
      </span>
      <span class="ml10">
        <span>{{ $t('message.MAXIMUM_SHORT') + $t('message.TWO_DOTS') }}</span>
        <InputNumber v-model="maxValue" @input="edited" />
      </span>
    </div>
  </div>
</template>

<script>
/**
 * Basically two number input fields, one for min, the other for max.
 *
 * @vue-prop {Object} [value={ min: 0, max: 3 }] - Min and max values as an object
 * @vue-prop {Number} [allowedMin=0] - Minimum allowed value for both fields
 * @vue-prop {Number} [allowedMax=3] - Maximum allowed value for both fields
 * @vue-prop {String} [legend] - Content of div with class 'legend'
 */
import InputNumber from '@/components/input-number.vue';
export default {
  name: 'MinMaxSelector',
  components: {
    InputNumber,
  },
  props: {
    value: {
      type: Object,
      default: () => ({ min: 0, max: 1 }),
    },
    allowedMin: {
      type: Number,
      default: 0,
    },
    allowedMax: {
      type: Number,
      default: 3, // Impact max value
    },
    legend: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      fieldsKey: 1,
      minValue: this.valueWithinRange(this.value.min),
      maxValue: this.valueWithinRange(this.value.max),
    };
  },
  methods: {
    edited() {
      this.$nextTick(() => {
        this.minValue = this.valueWithinRange(this.minValue);
        this.maxValue = this.valueWithinRange(this.maxValue);
        this.$emit('input', { min: this.minValue, max: this.maxValue });
      });
    },
    valueWithinRange(val) {
      if (val > this.allowedMax) {
        return this.allowedMax;
      }
      if (val < this.allowedMin) {
        return this.allowedMin;
      }
      return val;
    }
  }
};
</script>

<style lang="scss">
.min-max-selector {
  input.input-number {
    max-width: 50px;
  }
}
</style>
